import {DateTime} from 'luxon';

/**
 * Helper function to determine if an offer's duration overlaps with a given month
 * IMPORTANT: it returns false if the offer expires in the next seven days (if offset is 0 or 1)
 * @param offerStartDate offer's start date (ISO)
 * @param offerEndDate offer's end date (ISO)
 * @param monthOffset 0: current month; 1: next month; 2: third month from now;
 * @returns boolean
 */
export const doesOfferOverlapWithMonth = (
  offerStartDate: string,
  offerEndDate: string,
  monthOffset: number
): boolean => {
  const nextSevenDaysFromNow = DateTime.now().plus({days: 7}).endOf('day');
  const startDate = DateTime.fromISO(offerStartDate);
  const endDate = DateTime.fromISO(offerEndDate);
  const targetMonth = DateTime.now().plus({months: monthOffset});

  // Exclude offers that expire in the next seven days from current and next month offers
  if (monthOffset < 2 && endDate <= nextSevenDaysFromNow) {
    return false;
  }

  const targetMonthStart = targetMonth.startOf('month');
  const targetMonthEnd = targetMonth.endOf('month');

  return startDate <= targetMonthEnd && endDate >= targetMonthStart;
};
